<template>
  <div >
    <a v-if="hasPermission()" class="ls-btn ls-no-margin ls-float-right" @click.prevent="loadLog" style="margin-left: 5px">Visualizar Logs</a>
        &nbsp;
    <modal v-model="show" :klass="'ls-modal-large'">
      <div slot="content">
        <div class="ls-modal-header">
        <button close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">Log de contrato</h4>
      </div>
      <div class="ls-modal-body">
        <table class="ls-table">
          <thead>
            <th>Entidade/Horário</th>
            <th>Mensagem</th>
            <th>Autor</th>
          </thead>
          <tbody>
            <tr v-if="logs.lengt === 0">
              <td class="text-center" colspan="3">Não existem log</td>
            </tr>
            <tr v-for="log in logs">
              <td> {{ log.entity_type }} ({{ log.identifier_id }}) / {{ parseDate(log.created_at) }} </td>
              <td> {{ log.message }} </td>
              <td> {{ log.author }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn pull-right" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
      </div>
      </div>
    </modal>
  </div>
</template>
<script type="text/javascript">
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapActions } from 'vuex'

  export default {
    components: { Modal },
    props: ['id'],
    data () {
      return {
        show: false,
        logs: []
      }
    },
    methods: {
      ...mapActions(['showLogs']),
      loadLog () {
        this.show = true
        this.logs = []
        this.showLogs({'entity': 'contract', 'id': this.id}).then((response) => {
          if (response.status === 200) {
            this.logs = response.data.logs
          }
        })
      },
      parseDate (date) {
        let dateParsed = new Date(date)
        return dateParsed.toLocaleDateString('pt-BR') + ' ' + dateParsed.toTimeString()
      },
      hasPermission () {
        return JSON.parse(window.localStorage.user).admin
      },
      cancel () {
        this.show = false
        this.logs = []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalLog.vue?21da3f7a